import React from 'react';
import { TooltipV2 as Tooltip, TOOLTIP_POSITION, LightningIcon } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { InternalLink } from '../../../../components';
import { GTM_EVENTS } from '../../../taboola-common-frontend-modules/gtmTracker';
import { generatePerformanceRecommendationsReviewerPath } from '../../services/utils';
import styles from './campaignPickerListItemRecommendationsButton.module.scss';

export const CampaignPickerListItemRecommendationsButton = ({
    recommendationsCount,
    campaignId,
    accountId,
    accountName,
}) => {
    if (!accountName) {
        return null;
    }

    return (
        <div className={styles['recommendations-button-container']}>
            <InternalLink
                aria-label="Optimization Opportunities"
                className={styles['recommendations-button']}
                path={generatePerformanceRecommendationsReviewerPath({
                    accountId: accountName,
                    campaignId,
                })}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-visibility={GTM_EVENTS.VISIBLE}
                data-metrics-account-id={accountId}
                data-metrics-taboola-campaign-id={campaignId}
                data-metrics-component="CampaignPickerRecommendationsButton"
            >
                <LightningIcon />
            </InternalLink>
            <Tooltip position={TOOLTIP_POSITION.RIGHT} arrow offsetBody={1}>
                <FormattedMessage
                    id={`campaign.picker${recommendationsCount === 1 ? '.single' : ''}.recommendation`}
                    values={{ recommendationsCount }}
                />
            </Tooltip>
        </div>
    );
};
